type PageTitleProps = {
	title?: string;
};

export function PageTitle({ title }: PageTitleProps) {
	// document.title is safe to set during render:
	// - It's idempotent (setting the same value multiple times is safe)
	// - It doesn't trigger React re-renders
	// - Many React libraries do this (react-helmet, react-document-title, etc.)
	// - It's a browser API, not React state, so it doesn't violate React's rules
	// - The last component to render will have its title set, avoiding race conditions
	if (typeof document !== 'undefined' && title) {
		document.title = title;
	}

	return null;
}
